import * as React from 'react'
import { ReactElement } from 'react'
import { ITextFieldStyles, mergeStyleSets } from '@fluentui/react'
import EditableTextField, { EditableTextFieldProps } from '../Editable/EditableTextField'

type Props = EditableTextFieldProps & {
    isHeader?: boolean
}

type Styles = Pick<ITextFieldStyles, 'root' | 'field' | 'prefix' | 'suffix' | 'fieldGroup' | 'icon'>

export const listTextFieldStyles: Styles = mergeStyleSets({
    root: { margin: '-2px -4px' },
    field: { fontSize: '12px', padding: '0 4px' },
    prefix: { fontSize: '12px', padding: '0 4px' },
    suffix: { fontSize: '12px', padding: '0 4px' },
    fieldGroup: { height: '24px' },
    icon: { lineHeight: '12px' },
})

export const headerListTextFieldStyles: Styles = mergeStyleSets(listTextFieldStyles, {
    field: { fontSize: '14px' },
    prefix: { fontSize: '14px', padding: '0 4px' },
    suffix: { fontSize: '14px', padding: '0 4px' },
})

export default function ListTextField(props: Props): ReactElement {
    return <EditableTextField underlined styles={props.isHeader ? headerListTextFieldStyles : listTextFieldStyles} {...props} />
}
